import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { fmtTime } from "@/lib/api";

// Display-only stopwatch anchored to the server's started_at (server clock offset applied).
export function Stopwatch({ startedAt, serverNow, frozenMs }) {
  const [elapsed, setElapsed] = useState(frozenMs ?? 0);
  useEffect(() => {
    if (frozenMs != null) return setElapsed(frozenMs);
    const offset = new Date(serverNow).getTime() - Date.now();
    const start = new Date(startedAt).getTime();
    const tick = () => setElapsed(Math.max(0, Date.now() + offset - start));
    tick();
    const id = setInterval(tick, 500);
    return () => clearInterval(id);
  }, [startedAt, serverNow, frozenMs]);
  return (
    <span className="inline-flex items-center gap-1.5 font-mono text-base font-bold text-white" data-testid="set-stopwatch">
      <Timer size={14} className="text-blue-400" />{fmtTime(elapsed)}
    </span>
  );
}
